import { enumSchema } from "vue-utils"

export enum MarriageStageType {
	P1 = "P1",
	P2 = "P2",
}

export const MarriageStageTypeSchema = enumSchema(MarriageStageType)
